import React from "react";
import { Box, Typography, Paper, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Raptors = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // Center horizontally
        justifyContent: "center", // Center vertically
        padding: { xs: 2, sm: 3 },
        marginBottom: 20,
      }}
    >
      <Typography
        variant="h1"
        gutterBottom
        sx={{ fontSize: { xs: "2.5rem", sm: "3rem" }, textAlign: "center" }} // Center text
      >
        {t("raptors")}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 3,
          marginTop: 4,
          width: "100%", // Ensure the inner Box takes full width
          maxWidth: "1200px", // Optional: Limit the maximum width for better readability
        }}
      >
        {/* Teacher Section */}
        <Paper elevation={3} sx={{ padding: 2, flex: 1 }}>
          <Typography variant="h4" gutterBottom sx={{ textAlign: "center" }}>
            {t("teacher")}
          </Typography>

          <Button
            variant="contained"
            component={Link}
            to="/GetTeacherReportMonth"
            sx={{
              marginTop: 2,
              width: { xs: "100%", sm: "auto" },
              backgroundColor: "#ff5722",
              "&:hover": { backgroundColor: "#e64a19" },
              borderRadius: "8px",

              textTransform: "none",
              textAlign: "center",
              display: "block", // Ensure the button is centered
              mx: "auto", // Center the button horizontally
            }}
          >
            {t("teacherReportByMonth")}
          </Button>
          <Button
            variant="contained"
            component={Link}
            to="/GetTeacherReportYear"
            sx={{
              marginTop: 2,
              width: { xs: "100%", sm: "auto" },
              backgroundColor: "#673ab7",
              "&:hover": { backgroundColor: "#512da8" },
              borderRadius: "8px",

              textTransform: "none",
              textAlign: "center",
              display: "block", // Ensure the button is centered
              mx: "auto", // Center the button horizontally
            }}
          >
            {t("teacherReportByYear")}
          </Button>
        </Paper>

        {/* Student Section */}
        <Paper elevation={3} sx={{ padding: 2, flex: 1 }}>
          <Typography variant="h4" gutterBottom sx={{ textAlign: "center" }}>
            {t("student")}
          </Typography>

          <Button
            variant="contained"
            component={Link}
            to="/GetStudentReport"
            sx={{
              marginTop: 2,
              width: { xs: "100%", sm: "auto" },
              backgroundColor: "#ff9800",
              textAlign: "center",
              "&:hover": { backgroundColor: "#f57c00" },
              display: "block", // Ensure the button is centered
              mx: "auto", // Center the button horizontally
            }}
          >
            {t("allStudents")}
          </Button>
          <Button
            variant="contained"
            component={Link}
            to="/GetReportsTuitionPayments"
            sx={{
              marginTop: 2,
              width: { xs: "100%", sm: "auto" },
              backgroundColor: "#169976",
              textAlign: "center",
              "&:hover": { backgroundColor: "#169276" },
              display: "block", // Ensure the button is centered
              mx: "auto", // Center the button horizontally
            }}
          >
            {t("GetReportsTuitionPayments")}
          </Button>
          <Button
            variant="contained"
            component={Link}
            to="/GetUnpaidStudentsReport"
            sx={{
              marginTop: 2,
              width: { xs: "100%", sm: "auto" },
              backgroundColor: "#9c27b0",
              textAlign: "center",
              "&:hover": { backgroundColor: "#7b1fa2" },
              display: "block", // Ensure the button is centered
              mx: "auto", // Center the button horizontally
            }}
          >
            {t("notPaidInstallments")}
          </Button>
          <Button
            variant="contained"
            component={Link}
            to="/GetDiscountedStudent"
            sx={{
              marginTop: 2,
              width: { xs: "100%", sm: "auto" },
              textAlign: "center",
              backgroundColor: "#00bcd4",
              "&:hover": { backgroundColor: "#0097a7" },
              display: "block", // Ensure the button is centered
              mx: "auto", // Center the button horizontally
            }}
          >
            {t("discountedStudents")}
          </Button>
        </Paper>

        {/* Expenses Section */}
        <Paper elevation={3} sx={{ padding: 2, flex: 1 }}>
          <Typography variant="h4" gutterBottom sx={{ textAlign: "center" }}>
            {t("expenses")}
          </Typography>

          <Button
            variant="contained"
            component={Link}
            to="/GetExpensesReportToday"
            sx={{
              marginTop: 2,
              width: { xs: "100%", sm: "auto" },
              backgroundColor: "#207d8b",
              textAlign: "center",
              "&:hover": { backgroundColor: "#255a64" },
              display: "block", // Ensure the button is centered
              mx: "auto", // Center the button horizontally
            }}
          >
            {t("expensesReportByToday")}
          </Button>
          <Button
            variant="contained"
            component={Link}
            to="/GetExpensesReport"
            sx={{
              marginTop: 2,
              width: { xs: "100%", sm: "auto" },
              backgroundColor: "#607d8b",
              textAlign: "center",
              "&:hover": { backgroundColor: "#455a64" },
              display: "block", // Ensure the button is centered
              mx: "auto", // Center the button horizontally
            }}
          >
            {t("expensesReportByMonth")}
          </Button>
          <Button
            variant="contained"
            component={Link}
            to="/GetExpensesReportYears"
            sx={{
              marginTop: 2,
              width: { xs: "100%", sm: "auto" },
              backgroundColor: "#009688",
              textAlign: "center",
              "&:hover": { backgroundColor: "#00796b" },
              borderRadius: "8px",

              textTransform: "none",
              display: "block", // Ensure the button is centered
              mx: "auto", // Center the button horizontally
            }}
          >
            {t("expensesReportByYear")}
          </Button>
        </Paper>
      </Box>
    </Box>
  );
};

export default Raptors;
